var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-content-start grouping-container"},[_c('v-btn',{staticClass:"custom-btn",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.isGroupingObject ? 'Ungroup' : 'Group')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }